import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../page/about";
import Navbar from "../navbar";
import Footer from "../Footer";
import Covid19 from "../../asset/covid.png";
import "../Header/header.css";

const Covid = () => {
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">PROTOCOLS & PROCEDURES</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{ display: "flex", justifyContent: "center", padding: "50px 0" }}
      >
        <Grid item md={8} sx={{ display: "flex", justifyContent: "center" }}>
          <img className="covid" src={Covid19} alt="nothing" />
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ display: "flex", justifyContent: "center", padding: "50px 0" }}
      >
        <Grid item md={7}>
          <Typography className="restxt2">
            To protect yourself and others, we advise you to:
          </Typography>
          <ul>
            <li className="restxt">
              Use hand sanitiser when entering & leaving the mosque.
            </li>
            <li className="restxt">Wear face-coverings when inside.</li>
            <li className="restxt">Bring your own prayer mat.</li>
            <li className="restxt">Perform ablution at home.</li>
            <li className="restxt">
              Avoid hugging & shaking hands with anyone outside your household.
            </li>
            <li className="restxt">
              Pray at home if you are from a vulnerable group.
            </li>
            <li className="restxt">
              Stay home if you are unwell or displaying flu like symptoms.
            </li>
            <li className="restxt">
              Be mindful of those who prefer to socially distance.
            </li>
          </ul>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default Covid;
